import React from "react";
import styled from "styled-components";
import { Controller } from "react-hook-form";
import { Row, Col, Checkbox, Radio, Divider, Input } from "antd";
import { StyledTitle } from "pages/jobs/add";
import { PlusOutlined } from "@ant-design/icons";
import {
  StyledErrorCheckbox,
  StyledMainDivider,
  StyledMinimalButton,
} from "./finishingCheckbox";
import { StyledContainer } from "./coverSection";
import _ from "lodash";

const BindingCheckbox = (props) => {
  //  State
  const [selectedSecondOption, setSelectedSecondOption] = React.useState({});

  const {
    data,
    status,
    control,
    errors,
    setBindingModalVisible,
    setValue,
    watchBindings,
    trigger,
    watch,
    editMode,
  } = props;

  React.useEffect(() => {
    if (editMode && watch("selected_binding")) {
      const selectedBindingWithSecondOption = watch("selected_binding").filter(
        (binding) => binding.second_option && binding.second_option.length > 0
      );
      let formattedBindingSecondOption = {};
      selectedBindingWithSecondOption.map((binding) => {
        binding.second_option.map((secondOption) => {
          formattedBindingSecondOption[`${binding.name}-${secondOption.name}`] =
            secondOption.value;
          formattedBindingSecondOption = { ...formattedBindingSecondOption };
        });
      });
      setSelectedSecondOption(formattedBindingSecondOption);
    }
  }, [editMode, watch("selected_binding")]);

  if (status === "loading") {
    return <h1>Loading...</h1>;
  }

  return (
    <StyledContainer
      style={{ marginRight: "10px" }}
      error={_.get(errors, "bindings")}
    >
      <StyledMainDivider>Binding</StyledMainDivider>
      <>
        {errors && _.get(errors, "bindings") && (
          <Row>
            <StyledErrorCheckbox>
              <p>{errors && _.get(errors, `bindings.message`)}</p>
            </StyledErrorCheckbox>
          </Row>
        )}
      </>
      <Controller
        name="selected_binding"
        control={control}
        as={<Input type={"hidden"} />}
      />

      <Col span={24}>
        <Row type="flex">
          {data &&
            data.map((binding) => (
              <React.Fragment key={binding.id}>
                <Row
                  key={binding.id}
                  style={{ flexBasis: "100%", margin: "5px 0" }}
                >
                  <Controller
                    name="bindings"
                    type="checkbox"
                    control={control}
                    render={({ onChange, onBlur, value, name }) => {
                      return (
                        <Checkbox
                          onBlur={onBlur}
                          onChange={(e) => {
                            //cari dalam form state ada tak id yang sama dengan selected checkbox ni, kalau ada, delete
                            const index = watch("bindings").findIndex(
                              (bindingId) => bindingId === binding.id
                            );

                            if (index > -1) {
                              const bindingsIdArray = watch("bindings");
                              bindingsIdArray.splice(index, 1);
                              setValue("bindings", bindingsIdArray);

                              const selectedBindingArray = watch(
                                "selected_binding"
                              );
                              selectedBindingArray.splice(index, 1);
                              setValue(
                                "selected_binding",
                                selectedBindingArray
                              );
                            } else {
                              setValue("bindings", [
                                ...watch("bindings"),
                                binding.id,
                              ]);
                              setValue("selected_binding", [
                                ...watch("selected_binding"),
                                { name: binding.name },
                              ]);
                            }
                            trigger("bindings");
                          }}
                          checked={watch("bindings").includes(binding.id)}
                        >
                          {binding.name}
                        </Checkbox>
                      );
                    }}
                  />
                </Row>
                {/* Second Option */}
                {binding.second_option && watchBindings?.includes(binding.id) && (
                  <>
                    {binding.second_option.map((b, secondIndex) => (
                      <Col xs={24} key={`second-${secondIndex}`}>
                        <StyledBox>
                          <StyledTitle>{b.name}</StyledTitle>
                          <Radio.Group
                            onChange={(e) => {
                              const newSelectedSecondOption = {
                                ...selectedSecondOption,
                              };
                              newSelectedSecondOption[
                                `${binding.name}-${b.name}`
                              ] = e.target.value;
                              setSelectedSecondOption(newSelectedSecondOption);

                              const newObj = {
                                name: binding.name,
                                second_option: [
                                  {
                                    name: b.name,
                                    value: e.target.value,
                                  },
                                ],
                              };

                              const findIndex = watch(
                                "selected_binding"
                              ).findIndex(
                                (selectedBinding) =>
                                  selectedBinding.name === binding.name
                              );

                              if (findIndex > -1) {
                                const formSelectedSecondOption = watch(
                                  "selected_binding"
                                )[findIndex];

                                if (
                                  formSelectedSecondOption.second_option &&
                                  formSelectedSecondOption.second_option
                                    .length > 0
                                ) {
                                  const foundSelectedSecondOptionIndex = formSelectedSecondOption.second_option.findIndex(
                                    (formSecondOption) =>
                                      formSecondOption.name === b.name
                                  );

                                  if (foundSelectedSecondOptionIndex > -1) {
                                    const updatedArray = watch(
                                      "selected_binding"
                                    );
                                    updatedArray[findIndex]["second_option"][
                                      foundSelectedSecondOptionIndex
                                    ]["value"] = e.target.value;

                                    setValue("selected_binding", updatedArray);
                                  } else {
                                    const updatedArray = watch(
                                      "selected_binding"
                                    );
                                    updatedArray[findIndex][
                                      "second_option"
                                    ].push({
                                      name: b.name,
                                      value: e.target.value,
                                    });

                                    setValue("selected_binding", updatedArray);
                                  }
                                } else {
                                  const updatedArray = watch(
                                    "selected_binding"
                                  );
                                  updatedArray[findIndex] = newObj;
                                  setValue("selected_binding", updatedArray);
                                }
                              }
                            }}
                            value={`${
                              selectedSecondOption[`${binding.name}-${b.name}`]
                            }`}
                          >
                            {b.value.map((value, secondOptionIndex) => (
                              <Radio
                                value={value}
                                key={`second-option-${secondOptionIndex}`}
                              >
                                {value}
                              </Radio>
                            ))}
                          </Radio.Group>
                        </StyledBox>
                      </Col>
                    ))}
                  </>
                )}
              </React.Fragment>
            ))}
        </Row>
      </Col>

      <StyledMinimalButton
        onClick={() => setBindingModalVisible(true)}
        className="button"
        icon={<PlusOutlined />}
        type="link"
      >
        Add binding
      </StyledMinimalButton>
    </StyledContainer>
  );
};

const StyledBox = styled.div`
  margin-top: ${(props) => props.theme.spacing[2]};
  margin-bottom: ${(props) => props.theme.spacing[3]};
  padding: ${(props) => props.theme.spacing[3]};
  border: 1px solid ${(props) => props.theme.colors.grey[300]};
  display: flex;
  flex-direction: column;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: ${(props) => props.theme.spacing[4]};
`;
export default BindingCheckbox;
